// src/services/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore, writeBatch } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";

// Replace with your Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyAAYtxy-QVOMJ21pwrQPtLProXHuC9xH9k",
    authDomain: "totspal-62189.firebaseapp.com",
    projectId: "totspal-62189",
    storageBucket: "totspal-62189.firebasestorage.app",
    messagingSenderId: "316060688678",
    appId: "1:316060688678:web:2f0d94ea7ea26aefaa61e7",
    measurementId: "G-6GPM2C6WTY"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

export { app, auth, db, storage, writeBatch };